import Select from "@/components/common/Select";
import { postUserLanguage } from "@/modules/auth/api/user/language";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Language = () => {
  const { i18n, t } = useTranslation();
  const [lang, setLang] = useState(i18n.language);

  const handleChange = async (newLang: string) => {
    const success = await postUserLanguage(newLang);

    if (success) {
      i18n.changeLanguage(newLang);
      setLang(newLang);
    }
  };

  useEffect(() => {
    if (i18n.language !== lang) {
      setLang(i18n.language);
    }
  }, [i18n.language, lang]);

  const options = [
    { label: t("settings.language.en"), value: "en" },
    { label: t("settings.language.es"), value: "es" },
    { label: t("settings.language.ru"), value: "ru" },
    { label: t("settings.language.de"), value: "de" },
    { label: t("settings.language.zh"), value: "zh" },
    { label: t("settings.language.ko"), value: "ko" },
    { label: t("settings.language.tr"), value: "tr" },
    { label: t("settings.language.pt"), value: "pt" },
    { label: t("settings.language.jp"), value: "jp" },
  ];

  return (
    <div className="flex w-full flex-col">
      <p className="p-4 pb-2 text-[0.8125rem] leading-[1rem] text-section-header-text tracking-tighter uppercase">
        {t("settings.language.title")}
      </p>

      <Select value={lang} onChange={handleChange} options={options} />
    </div>
  );
};

export default Language;
